import { environment } from '@env/environment';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ExamsByCode } from '../templates/exams-config/ExamsByCode.class';
import { DatabaseService } from '@app/database/database.service';
import { ShowExamnsTemplateContainerService } from './show-examns-template-container.service';
import { Observable } from 'rxjs';
import moment from 'moment';

@Component({
  selector: 'app-show-examns-template-container',
  templateUrl: './show-examns-template-container.component.html',
  styleUrls: ['./show-examns-template-container.component.scss']
})
export class ShowExamnsTemplateContainerComponent implements OnInit {
  examsByCode = new ExamsByCode().data;
  examData: any;
  examenDataFromSIngleService
  selectedTemplate: any;

  constructor(
    private databaseService: DatabaseService,
    private showExamnsTemplateService: ShowExamnsTemplateContainerService,
    private actRoute: ActivatedRoute
  ) {
    this.showExamnsTemplateService.examData.subscribe(
      (examData) => (this.examData = examData)
    );
  }

  async ngOnInit(): Promise<void> {
    if (!this.examData.isExamenPorEnviar) {
      await this.getSingleExamenData()
        .subscribe(
          async (results) => {
            // console.log('GET SINGLE DATA Data del item particular cargado', results.body);
            this.buildObjectForTemplateFromService(results.response).then( async () => {
              await this.setTemplateToExamen();
            } )
          },
          async (error) => {
            console.log('ERROR ON GET SINGLE DATA al filtrar examenes cargados: ', error);
            // this.getExamenesCargadosOffline();
          });
    } else {
      this.buildObjectForTemplateFromPorEnviar().then( async () => {
        await this.setTemplateToExamen();
      } )
    }
  }

  /**
   * refactor para unir template y examen sin perder la vista actual
   */
  private async setTemplateToExamen(): Promise<void> {
    const examId = this.actRoute.snapshot.params.id;
    const examCode = this.actRoute.snapshot.params.codigoTipoExamen;

    const examenTable = "periodicos"; // await this.actRoute.snapshot.params.categoriaExamen;
    // this.examData = await this.databaseService.getSingleExamenItem(examenTable, parseInt(examId, 10));

    this.selectedTemplate = await this.examsByCode[examCode];
  }

  private getSingleExamenData(): Observable<any> {
    return this.showExamnsTemplateService.getSingleExamenData(this.examData.id, this.examData.tipoEstudio.tipoEstudioCod);

  }

  async buildObjectForTemplateFromService(data: any): Promise<void> {
    this.examData.fechaRealizacion = this._UTCDateFechaRealizacion(this.examData);
    const finalRemapedData = { modoVista: 'ver', ...this.examData, ...data };
    this.examData = finalRemapedData;
  }

  async buildObjectForTemplateFromPorEnviar(): Promise<void> {
    this.examData.examenData.fechaRealizacion = this._UTCDateFechaRealizacion(this.examData.examenDataToSend);
    this.examData.examenDataToSend.fechaRealizacion = this._UTCDateFechaRealizacion(this.examData.examenDataToSend);
    this.examData.examenData.edad = this._calculateAge(this.examData);
    this.examData.examenDataToSend.edad = this._calculateAge(this.examData);
    this.examData.examenData.attachments = this.examData.examenDataToSend.adjuntos;

    const finalRemapedTrabajadorData = {
      ...this.examData.examenData.trabajador,
      ...this.examData.examenDataToSend.trabajador
    };

    const finalRemapedData = {
      ...this.examData.examenData,
      ...this.examData.examenDataToSend,
      'trabajador': finalRemapedTrabajadorData,
      "abierto": true,
      "modoVista": "ver"
    };

    this.examData = finalRemapedData;
    const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
    this.examData.medicoLaboralVista = especialidadesListFromOffline.filter((medico) => medico.id == this.examData.medicoLaboral ? medico : null)[0];
    // console.log('Final data build fron Examenes Por Enviar', finalRemapedData);
  }

  private calculateAge(fechaNacimiento: string): any {
    let edad = null;
    if (fechaNacimiento) {
      edad = moment().diff(
        moment(fechaNacimiento),
        'years'
      );
    }
    return edad;
  }


  // HELPERS
  /**
   *
   * @param data
   * @returns {Date}
   */
   _UTCDateFechaRealizacion(data: any) {
    let splitedDate = data.fechaRealizacion ? data.fechaRealizacion.split('-') : null;
    return splitedDate ? new Date(splitedDate[0], splitedDate[1] -1, splitedDate[2]) : new Date();
  }

  _calculateAge(data: any) {
    let edad = null;
    if ( data.edad ) {
      return data.edad;
    } else if (data.examenDataToSend.edad) {
      return data.examenDataToSend.edad
    } else if (data.examenData.trabajador.fechaNacimiento) {
      edad = moment().diff(
        moment(data.examenData.trabajador.fechaNacimiento),
        'years'
      );
    }
    return edad;
  }
}

